import React from 'react'

import { UniversityMarkerIcon } from '@guiker/icons'

import { Marker, MarkerProps } from './Marker'

export const University: React.FC<Omit<MarkerProps, 'icon'>> = ({ ...props }) => {
  return <Marker icon={<UniversityMarkerIcon />} {...props} />
}
